module.exports = __webpack_public_path__ + "img/xitifanli.a0815fbe.png";